// Επαναπροσδιορισμός ανακοπών (Ν. 5221/2025). The backend sends the status on
// each case as `epanaprosdiorismos` (null when the case is not affected):
//   { role: "old", status: "pending" | "filed", window, opens, deadline, old_hearing }
//   { role: "application", katathesi, prothesmies: [{ code, onoma, prothesmia }] }
// Dates are ISO (YYYY-MM-DD).

const formatIso = (iso) => (iso ? iso.split("-").reverse().join(".") : "");

const todayIso = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

const daysBetween = (fromIso, toIso) =>
  Math.round(
    (Date.parse(`${toIso}T00:00:00Z`) - Date.parse(`${fromIso}T00:00:00Z`)) /
      86400000
  );

const daysLeftText = (deadline) => {
  const left = daysBetween(todayIso(), deadline);
  if (left < 0) return "η προθεσμία έληξε";
  if (left === 0) return "λήγει σήμερα";
  return left === 1 ? "σε 1 ημέρα" : `σε ${left} ημέρες`;
};

const EpanaprosdiorismosAlert = ({ status }) => {
  if (!status) return null;

  if (status.role === "application") {
    const today = todayIso();
    const next = status.prothesmies?.find((p) => p.prothesmia >= today);
    if (!next) return null;
    return (
      <div className="epan-alert epan-alert--info" role="note">
        <span className="epan-alert__label">
          Αίτηση επαναπροσδιορισμού (Ν. 5221/2025)
        </span>
        <span className="epan-alert__result">
          {next.onoma}: έως {formatIso(next.prothesmia)} (
          {daysLeftText(next.prothesmia)})
        </span>
      </div>
    );
  }

  if (status.status === "filed") {
    return (
      <div className="epan-alert epan-alert--info" role="note">
        <span className="epan-alert__label">
          Επαναπροσδιορισμός ανακοπής (Ν. 5221/2025)
        </span>
        <span className="epan-alert__result">
          Κατατέθηκε αίτηση επαναπροσδιορισμού
        </span>
        <span className="epan-alert__meta">
          {status.old_hearing &&
            `Η δικάσιμος της ${formatIso(status.old_hearing)} δεν ισχύει. `}
          Η νέα δικάσιμος θα οριστεί στην αίτηση, που έχει δικό της ΓΑΚ:
          προσθέστε την για να την παρακολουθείτε.
        </span>
      </div>
    );
  }

  const notYetOpen = status.opens && todayIso() < status.opens;
  return (
    <div className="epan-alert" role="alert">
      <span className="epan-alert__label">
        <span aria-hidden="true">⚠</span> Επαναπροσδιορισμός ανακοπής (Ν.
        5221/2025)
      </span>
      <span className="epan-alert__result">
        {notYetOpen
          ? `Αίτηση επαναπροσδιορισμού από ${formatIso(status.opens)} έως ${formatIso(status.deadline)}`
          : `Αίτηση επαναπροσδιορισμού έως ${formatIso(status.deadline)} (${daysLeftText(status.deadline)})`}
      </span>
      <span className="epan-alert__meta">
        Αν δεν κατατεθεί, η ανακοπή λογίζεται ως μη ασκηθείσα και τυχόν
        προσωρινή διαταγή ή αναστολή εκτέλεσης ανακαλείται αυτοδικαίως. Ελέγξτε
        αν η υπόθεση υπάγεται: δεν υπάγονται οι ανακοπές των άρθ. 954 §4 και 973
        §6 ΚΠολΔ, ούτε όταν επισπεύδεται πλειστηριασμός πριν από το κλείσιμο του
        φακέλου της νέας διαδικασίας (άρθ. 130 §4 Ν. 5221/2025).
      </span>
    </div>
  );
};

export default EpanaprosdiorismosAlert;
